import moment, { Moment } from 'moment';
import React, { FC } from 'react';
import styled from 'styled-components';
import { HumanisedDate } from 'components/atoms/humanised-date';
import { Text02 } from 'components/styles';
import { useTranslation } from 'hooks/use-translation';

const Wrapper = styled.span`
  display: block;
  text-align: center;
  position: sticky;
  padding: var(--spacing-03);
  top: 0;
  left: 0;
  z-index: 1;
`;

const DateContent = styled.span`
  ${Text02};
  background: var(--white-100);
  border-radius: var(--border-radius-curved);
  box-shadow: var(--shadow-02);
  display: inline-block;
  font-size: var(--font-size-sm);
  line-height: var(--line-height-caption-01);
  letter-spacing: 0.32px;
  min-width: 110px;
  padding: var(--spacing-02) var(--spacing-03);
  position: relative;
  z-index: 1;
`;

type FloatingDateProps = {
  timestamp: Moment;
};

const DateToFromNowDaily: FC<FloatingDateProps> = ({ timestamp }) => {
  const fromNow = timestamp.diff(moment(), 'days');
  const today = useTranslation('today');
  const yesterday = useTranslation('yesterday');

  switch (fromNow) {
    case 0:
      return <>{today}</>;
    case -1:
      return <>{yesterday}</>;
    default:
      return <HumanisedDate timestamp={timestamp} />;
  }
};

export const FloatingDate: FC<FloatingDateProps> = ({ timestamp }) => {
  return (
    <Wrapper>
      <DateContent>
        <DateToFromNowDaily timestamp={timestamp} />
      </DateContent>
    </Wrapper>
  );
};
